import React, { useRef, useState, useEffect } from "react";
import { CardContent, Grid, Box } from "@mui/material";
import { FormikProps } from "formik";
import { IActiveModal } from "src/pages/Admin/AdminWindow";
import { CrewScheduleForm } from "./CrewScheduleForm";
import { getClientSetting } from "src/redux/actions/App.Actions";
import { useCancellablePromise } from "src/API/useCancellablePromise";
import { getCrewGroups } from "src/redux/actions/CrewSchedule/CrewSchedule.Actions";
import { IClientSettings, ICrewGroupReleaseSchedule, ClientSettingName } from "@vmosolutions/oc-interfaces";
import LoadingWrapper from "src/components/LoadingWrapper/LoadingWrapper";
interface IManageCrewScheduleProps {
  id: string;
  setActiveModal: (activeModal: IActiveModal) => void;
  height: number;
}

export type CrewGroupReleaseScheduleForm = FormikProps<ICrewGroupReleaseSchedule>;

export const ManageCrewSchedule = (props: IManageCrewScheduleProps): JSX.Element => {
  const { cancellablePromise } = useCancellablePromise();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { setActiveModal, height } = props;
  const [crewGroups, setCrewGroups] = useState<string[]>([]);
  const [crewGroupReleaseScheduleSetting, setCrewGroupReleaseScheduleSetting] = useState<IClientSettings>();
  const contentRef = useRef<HTMLDivElement>();
  useEffect(() => {
    const getCrewGroupsAction = async (): Promise<void> => {
      setIsLoading(true);
      const crewGroupsResp = await cancellablePromise(getCrewGroups());
      const crewGroupReleaseScheduleClientSetting = await cancellablePromise(
        getClientSetting(ClientSettingName.CrewGroupReleaseSchedule)
      );

      setCrewGroupReleaseScheduleSetting(crewGroupReleaseScheduleClientSetting);
      setCrewGroups(crewGroupsResp.sort());
      setIsLoading(false);
    };
    getCrewGroupsAction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CardContent>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          {isLoading ? (
            <Box sx={{ p: 5 }}>
              <LoadingWrapper message="Loading Schedule Dates" />
            </Box>
          ) : (
            <CrewScheduleForm
              height={height}
              crewGroups={crewGroups}
              crewGroupReleaseScheduleSetting={crewGroupReleaseScheduleSetting}
              setActiveModal={setActiveModal}
            />
          )}
        </Grid>
      </Grid>
    </CardContent>
  );
};
